import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

const pinia = createPinia()

// Gestion d'erreur globale
const app = createApp(App)

app.config.errorHandler = (err: unknown) => {
  if (err instanceof Error && err.message && err.message.includes('parentNode')) {
    router.push('/404')
  }
}

// Gestion d'erreur pour les promesses non gérées
window.addEventListener('unhandledrejection', event => {
  // Si c'est une erreur de chargement de composant, rediriger vers 404
  if (event.reason instanceof Error && event.reason.message && event.reason.message.includes('parentNode')) {
    router.push('/404')
  }
})

import './assets/css/tailwind.css' // Tailwind en premier
import './assets/scss/main.scss' // SCSS en dernier pour override si nécessaire

app.use(pinia)
app.use(router)

// Initialiser l'authentification et monter l'app
async function initApp() {
  // const authStore = useAuthStore()
  
  // Si pas déjà authentifié (après login), vérifier l'auth
  // if (!authStore.user) {
  //   await authStore.checkAuth()
  // }
  
  app.mount('#app')
}

initApp()
